import OnboardingChecklist from './OnboardingChecklist'
import Resources from './Resources'
import Breadcrumbs from '@components/Breadcrumbs'
const Home = () => (
  <>
    <Breadcrumbs>
      <Breadcrumbs.Link label='Home' to={`/educators`} />
    </Breadcrumbs>
    <div className='flex flex-col md:flex-row p-8 gap-8'>
      <div className='grow flex justify-center'>
        <div className='md:max-w-2xl'>
          <h1 className='text-2xl font-extrabold tracking-tight'>
            Welcome to Mindjoy!
          </h1>
          <p className='mt-5 mb-7'>
            Mindjoy makes AI-powered teaching effortless! Plan lessons, engage students with interactive learning, and gain insights - all in one place.
          </p>
          <h2 className='font-semibold my-4'>
            🚀 Get Started
          </h2>
          <OnboardingChecklist />
        </div>
      </div>
      <div className='basis-2xs'>
        <h3 className='font-bold mb-4'>
          Resources
        </h3>
        <div>
          <Resources />
        </div>
      </div>
    </div>
  </>
)

export default Home
